<template>
  <div>
    <div class="mobile_login" style="width: 72%;transform: translate(-50%);margin-left: 50%;">
      <el-form ref="form" :model="info" >
        <el-form-item prop="username">
          <el-input
              class="readonly"
              size="medium"
              placeholder="手机号"
              required=""
              v-model="info.mobile"
          ></el-input>
        </el-form-item>

        <!-- 新增图形验证码表单项 -->
        <el-form-item prop="captcha">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="14">
              <el-input
                  size="medium"
                  v-model="captchaInput"
                  placeholder="图形验证码"
              ></el-input>
            </el-col>
            <el-col :span="8">
              <div class="captcha-img-wrapper" @click="refreshCaptcha">
                <img :src="captchaImgUrl" alt="验证码" class="captcha-img" v-if="captchaImgUrl"/>
                <span v-else class="captcha-loading">加载中...</span>
              </div>
            </el-col>
            <el-col :span="2" class="refresh-icon">
              <i class="el-icon-refresh-right" @click="refreshCaptcha"></i>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item prop="password">
          <el-row type="flex" class="row-bg">
            <el-col :span="14" ><el-input
                size="medium"
                class="readonly"
                v-model="info.code"
                placeholder="验证码"
            ></el-input></el-col>
            <el-col :span="5" ><el-button size="medium" class="yzm" :disabled="sendBtn" @click="getCode" >{{ codeText }}</el-button></el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" class="yzm" style="width: 100%" @click="login">立即登录</el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: center;color: #CCCCCC;line-height:32px;font-size:14px;margin-bottom: 3%;">
        新手机号将自动注册
      </div>
    </div>
  </div>
</template>

<script>
import verifyRange from '@/components/verifyRange';
import {
  codeLogin,
  getIdentifyCode,
  WxBindAccount,
  getCaptchaImage   // 新增图形验证码接口，需在 api/common 中定义
} from '@/api/common';
import utils from '@/assets/js/utils';
import {
  mapActions
} from 'vuex';
export default {
  name: "PhoneLogin",
  data(){
    return {
      info:{
        mobile: '',
        code: ''
      },
      timer: null,
      codeText: '获取验证码',
      autoHeight: 0,
      sendBtn:false,
      // 图形验证码相关数据
      captchaInput: '',      // 用户输入的图形验证码
      captchaKey: '',        // 图形验证码唯一标识，后端返回
      captchaImgUrl: '',     // 图形验证码图片地址
    }
  },

  mounted() {
    // 页面加载时获取图形验证码
    this.refreshCaptcha();
  },

  beforeDestroy() {
    // 清除倒计时定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  methods: {
    ...mapActions(['getCommunal']),

    /**
     * 获取图形验证码
     */
    async refreshCaptcha() {
      try {
        // 调用后端接口获取图形验证码，后端返回图片URL和唯一key
        // 接口约定返回格式：{ data: { imgUrl: 'base64或url', key: 'uuid' }, status: 200 }
        const res = await getCaptchaImage();
        console.log('res', res);
        if (res.status === 200 && res.data) {
          this.captchaImgUrl = res.data.imgUrl;
          this.captchaKey = res.data.key;
          // 每次刷新验证码，清空之前的输入
          this.captchaInput = '';
        } else {
          console.error('获取图形验证码失败');
        }
      } catch (error) {
        console.error('获取图形验证码异常', error);
      }
    },

    /**
     * 获取短信验证码
     */
    async getCode() {
      // 防止倒计时中重复点击
      if (this.timer) return;

      const { mobile } = this.info;
      if (!mobile) {
        this.$message('请输入您的手机号');
        return;
      } else {
        if (!/^1[0123456789]\d{9}$/.test(mobile)) {
          this.$message('手机号码有误');
          return;
        }
      }

      // 校验图形验证码
      if (!this.captchaInput) {
        this.$message('请输入图形验证码');
        return;
      }
      if (!this.captchaKey) {
        this.$message('图形验证码无效，请刷新重试');
        await this.refreshCaptcha();
        return;
      }

      // 禁用获取按钮，避免重复请求
      this.sendBtn = true;

      const obj = {
        type: '1',
        mobile: mobile,
        captchaCode: this.captchaInput,   // 用户输入的图形验证码
        captchaKey: this.captchaKey       // 图形验证码唯一标识
      };

      try {
        const { status, message } = await getIdentifyCode(obj);

        if (status !== 200) {
          // 请求失败，提示错误，刷新图形验证码，恢复按钮状态
          //this.$message.error(message || '获取验证码失败，请重试');
          await this.refreshCaptcha();
          this.sendBtn = false;
          return;
        }

        // 发送成功，显示60s倒计时
        this.countDown();
        // 发送成功后刷新图形验证码，防止重复使用
        await this.refreshCaptcha();
      } catch (error) {
        console.error('获取验证码异常', error);
        //this.$message.error('获取验证码失败，请重试');
        await this.refreshCaptcha();
        this.sendBtn = false;
      }
    },

    countDown() {
      const TIME_COUNT = 60;
      let _time_count = 60;
      if (!this.timer) {
        this.sendBtn = true;
        this.codeText = '已发送' + _time_count + 's';
        this.timer = setInterval(() => {
          if (_time_count > 0 && _time_count <= TIME_COUNT) {
            this.codeText = '已发送' + _time_count-- + 's';
          } else {
            this.sendBtn = false;
            this.codeText = '重新获取';
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    async login() {
      const {
        mobile,
        code
      } = this.info;
      if (!mobile) {
        this.$message('请输入您的手机号');
        return;
      } else {
        if (!/^1[0123456789]\d{9}$/.test(mobile)) {
          this.$message('手机号码有误');
          return;
        }
      }
      if (!code) {
        this.$message('请输入您的手机验证码');
        return;
      }
      if (this.isBing){
        this.bingUser();
        return;
      }
      const obj = {
        account: this.info.mobile,
        code: this.info.code
      };
      const {
        data,
        status
      } = await codeLogin(obj);
      if (status !== 200) return;
      utils.setCookie('X-Access-Token', data.user_access_token.token, 7);
      // this.update_expiry_time(data.user_access_token.expiry_time);
      this.getCommunal();
      this.$router.push('./order-list');
    },

    async bingUser(){
      var WxUserInfo = utils.getSession('WxUserInfo');
      if (!WxUserInfo){
        this.$message('请返回登录重新登录');
        return;
      }

      const obj = {
        account: this.info.mobile,
        code: this.info.code,
        WxUserInfo:WxUserInfo
      };

      const {
        data,
        status
      } = await WxBindAccount(obj);
      if (status !== 200) return;
      utils.setCookie('X-Access-Token', data.user_access_token.token, 7);
      // this.update_expiry_time(data.user_access_token.expiry_time);
      this.getCommunal();
      this.$router.push('/order-list');
    }
  },

  components: {
    verifyRange
  }
}
</script>

<style scoped>
/* 图形验证码样式 */
.captcha-img-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  cursor: pointer;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
}
.captcha-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.captcha-loading {
  font-size: 12px;
  color: #999;
}
.refresh-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  color: #ff8e1c;
}
.refresh-icon:hover {
  opacity: 0.8;
}
</style>

<style>
.el-tabs__item:hover {
  color: #ff8e1c;
  border-bottom-color: #ff8e1c;
}
.el-tabs__item.is-active {
  color: #ff8e1c;
  border-bottom-color: #ff8e1c;
}

.el-tabs__active-bar{
  background-color:#ff8e1c;
}

.el-tabs__nav{
  margin-left:20%;
}

.yzm{
  color: #fff;
  background-color: #ff8e1c;
  border-color: #ff8e1c;
}

.yzm:hover,
.yzm:focus {
  background: #ff8e1c;
  border-color: #ff8e1c;
  color: #fff;
}

.el-input__inner:focus {
  border: #ff8e1c 1px solid;
}

.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
  margin-bottom:25px;
}
</style>